// extracted by css-extract-rspack-plugin
export default {"inviteUserModalFormFields":"InviteUserModal_inviteUserModalFormFields__2EepH","helpLink":"InviteUserModal_helpLink__eTEmw"};